<template>
  <div>
    <div class="alert alert-info">
      Kolom isian dengan tanda bintang (<span style="color: red">*</span>) adalah wajib untuk di isi. <strong>{{messages}}</strong>
    </div>
    <center>
      <pulse-loader style="margin: 15px" :loading="loading" color="#696969" size="10px"></pulse-loader>
    </center>
      <input type="checkbox" id="checkboxIbu" style="margin-left: 10px" v-model="checkboxIbu">
      <label for="checkboxIbu">Tidak Memiliki Ibu</label>
    <form class="form-horizontal form-space" onsubmit="return false">
      <div v-show="isExist('NM_IBU') && !checkboxIbu" :class="{'form-group': true, 'has-error': errors.has('nama_lengkap_ibu')}">
        <label class="col-md-3"><span class="required-label">*</span>Nama Lengkap Ibu</label>
        <div class="col-md-6">
          <input
            type="text"
            name="nama_lengkap_ibu"
            placeholder="Nama Lengkap Ibu"
            class="form-control"
            maxlength="32"
            v-model="model.nama_lengkap_ibu"
            v-validate="isExist('NM_IBU') && !checkboxIbu ? 'required' : ''"
          >
          <span v-show="errors.has('nama_lengkap_ibu')" class="error-label">Isi Nama Lengkap Ibu</span>
        </div>
      </div>
      <div v-show="isExist('STATUS_IBU') && !checkboxIbu" :class="{'form-group': true, 'has-error': errors.has('status_ibu')}">
        <label class="col-md-3"><span class="required-label">*</span>Status Ibu</label>
        <div class="col-md-4">
          <select
            type="text"
            name="status_ibu"
            class="form-control"
            v-model="model.status_ibu"
            v-validate="isExist('STATUS_IBU') && !checkboxIbu ? 'required' : ''"
          >
            <option value="null" hidden>Pilih Status</option>
            <option v-for="status in options.status" :key="status.id_status" :value="status.id_status">
              {{ status.nama_status }}
            </option>
          </select>
          <span v-show="errors.has('status_ibu')" class="error-label">Pilih Status Ibu</span>
        </div>
      </div>
      <div v-show="isExist('TPT_LAHIR_IBU') && !checkboxIbu" :class="{'form-group': true, 'has-error': errors.has('tempat_lahir_ibu')}">
        <label class="col-md-3"><span class="required-label">*</span>Tempat Lahir Ibu</label>
        <div class="col-md-6">
          <input
            type="text"
            name="tempat_lahir_ibu"
            placeholder="Tempat Lahir Ibu"
            class="form-control"
            maxlength="25"
            v-model="model.tempat_lahir_ibu"
            v-validate="isExist('TPT_LAHIR_IBU') && !checkboxIbu ? 'required' : ''"
          >
          <span v-show="errors.has('tempat_lahir_ibu')" class="error-label">Isi Tempat Lahir Ibu</span>
        </div>
      </div>
      <div v-if="isExist('TGL_LAHIR_IBU') && !checkboxIbu" :class="{'form-group': true, 'has-error': errors.has('tanggal_lahir_ibu')}">
        <label class="col-md-3"><span class="required-label">*</span>Tanggal Lahir Ibu</label>
        <div class="col-md-4">
          <datetimepicker name="tanggal_lahir_ibu"
            format="YYYY/MM/DD"
            :value="this.model.tanggal_lahir_ibu"
            placeholder="Tanggal Lahir Ibu"
            v-validate="isExist('TGL_LAHIR_IBU') && !checkboxIbu ? 'required' : ''"
            data-vv-validate-on="blur"
            @update-date="updateTglLahir">
          </datetimepicker>
          <span v-show="errors.has('tanggal_lahir_ibu')" class="error-label">Isi Tanggal Lahir Ibu</span>
        </div>
      </div>
      <div v-show="isExist('AGAMA_IBU') && !checkboxIbu" :class="{'form-group': true, 'has-error': errors.has('id_agama_ibu')}">
        <label class="col-md-3"><span class="required-label">*</span>Agama</label>
        <div class="col-md-4">
          <select
            type="text"
            name="id_agama_ibu"
            class="form-control"
            v-model="model.id_agama_ibu"
            v-validate="isExist('AGAMA_IBU') && !checkboxIbu ? 'required' : ''"
          >
            <option value="null" hidden>Pilih Agama</option>
            <option v-for="agama in options.agama" :key="agama.id" :value="agama.id_agama">
              {{ agama.nama_agama }}
            </option>
          </select>
          <span v-show="errors.has('id_agama_ibu')" class="error-label">Pilih Agama</span>
        </div>
      </div>
      <div v-show="isExist('PEND_IBU') && !checkboxIbu" :class="{'form-group': true, 'has-error': errors.has('id_jenjang_pendidikan_ibu')}">
        <label class="col-md-3"><span class="required-label">*</span>Pendidikan</label>
        <div class="col-md-4">
          <select
            type="text"
            name="id_jenjang_pendidikan_ibu"
            class="form-control"
            v-model="model.id_jenjang_pendidikan_ibu"
            v-validate="isExist('PEND_IBU') && !checkboxIbu ? 'required' : ''"
          >
            <option value="null" hidden>Pilih Pendidikan</option>
            <option v-for="jenjang in options.jenjang" :key="jenjang.id" :value="jenjang.id_jenjang">
              {{ jenjang.nama_jenjang }}
            </option>
          </select>
          <span v-show="errors.has('id_jenjang_pendidikan_ibu')" class="error-label">Pilih Pendidikan</span>
        </div>
      </div>
      <div v-show="isExist('PEKERJAAN_IBU') && !checkboxIbu" :class="{'form-group': true, 'has-error': errors.has('pekerjaan_ibu')}">
        <label class="col-md-3"><span class="required-label">*</span>Pekerjaan Ibu</label>
        <div class="col-md-4">
          <select
            type="text"
            name="pekerjaan_ibu"
            class="form-control"
            v-model="model.pekerjaan_ibu"
            v-validate="isExist('PEKERJAAN_IBU') && !checkboxIbu ? 'required' : ''"
          >
            <option value="null" hidden>Pilih Pekerjaan Ibu</option>
            <option v-for="pekerjaan in options.pekerjaan" :key="pekerjaan.id" :value="pekerjaan.id_pekerjaan">
              {{ pekerjaan.nama_pekerjaan }}
            </option>
          </select>
          <span v-show="errors.has('pekerjaan_ibu')" class="error-label">Pilih Pekerjaan Ibu</span>
        </div>
      </div>
      <div v-show="isExist('NEGARA') && !checkboxIbu" :class="{'form-group': true, 'has-error': errors.has('id_negara_ibu')}">
        <label class="col-md-3"><span class="required-label">*</span>Negara Asal</label>
        <div class="col-md-4">
          <select
            type="text"
            name="id_negara_ibu"
            class="form-control"
            v-model="model.id_negara_ibu"
            v-validate="isExist('NEGARA') && !checkboxIbu ? 'required' : ''"
          >
            <option value="null" hidden>Pilih Negara Asal</option>
            <option v-for="negara in options.negara" :key="negara.id" :value="negara.kode_negara">
              {{ negara.nama_negara }}
            </option>
          </select>
          <span v-show="errors.has('id_negara_ibu')" class="error-label">Pilih Negara Asal</span>
        </div>
      </div>
      <div v-show="isExist('PROVINSI') && !checkboxIbu" :class="{'form-group': true, 'has-error': errors.has('prop_ibu')}">
        <label class="col-md-3"><span class="required-label">*</span>Provinsi</label>
        <div class="col-md-4">
          <select
            type="text"
            name="prop_ibu"
            class="form-control"
            v-model="model.prop_ibu"
            v-validate="isExist('PROVINSI') && !checkboxIbu ? 'required' : ''"
            v-on:change="() => onChangeProvinsi(true)"
          >
            <option value="null" hidden>Pilih Provinsi</option>
            <option v-for="provinsi in options.provinsi" :key="provinsi.id" :value="provinsi.kode_provinsi">
              {{ provinsi.nama_provinsi }}
            </option>
          </select>
          <span v-show="errors.has('prop_ibu')" class="error-label">Pilih Provinsi</span>
        </div>
      </div>
      <div v-show="isExist('KABUPATEN') && !checkboxIbu" :class="{'form-group': true, 'has-error': errors.has('kab_ibu')}">
        <label class="col-md-3"><span class="required-label">*</span>Kabupaten</label>
        <div class="col-md-4">
          <select
            type="text"
            name="kab_ibu"
            class="form-control"
            v-model="model.kab_ibu"
            v-validate="isExist('KABUPATEN') && !checkboxIbu ? 'required' : ''"
            v-on:change="() => onChangeKabupaten(true)"
          >
            <option value="null" hidden>Pilih Kabupaten</option>
            <option v-for="kabupaten in options.kabupaten" :key="kabupaten.id" :value="kabupaten.kode_kabupaten">
              {{ kabupaten.nama_kabupaten }}
            </option>
          </select>
          <span v-show="errors.has('kab_ibu')" class="error-label">Pilih Kabupaten</span>
          <pulse-loader style="margin: 15px" :loading="loadingKabupaten" color="#696969" size="10px"></pulse-loader>
        </div>
      </div>
      <div v-show="isExist('KECAMATAN') && !checkboxIbu" :class="{'form-group': true, 'has-error': errors.has('kec_ibu')}">
        <label class="col-md-3"><span class="required-label">*</span>Kecamatan</label>
        <div class="col-md-4">
          <select
            type="text"
            name="kec_ibu"
            class="form-control"
            v-model="model.kec_ibu"
            v-validate="isExist('KECAMATAN') && !checkboxIbu ? 'required' : ''"
          >
            <option value="null" hidden>Pilih Kecamatan</option>
            <option v-for="kecamatan in options.kecamatan" :key="kecamatan.id" :value="kecamatan.kode_kecamatan">
              {{ kecamatan.nama_kecamatan }}
            </option>
          </select>
          <span v-show="errors.has('kec_ibu')" class="error-label">Pilih Kecamatan</span>
          <pulse-loader style="margin: 15px" :loading="loadingKecamatan" color="#696969" size="10px"></pulse-loader>
        </div>
      </div>
      <div v-show="isExist('KELURAHAN') && !checkboxIbu" :class="{'form-group': true, 'has-error': errors.has('desa_ibu')}">
        <label class="col-md-3"><span class="required-label">*</span>Kelurahan</label>
        <div class="col-md-6">
          <input
            type="text"
            name="desa_ibu"
            placeholder="Kelurahan"
            class="form-control"
            maxlength="25"
            v-model="model.desa_ibu"
            v-validate="isExist('KELURAHAN') && !checkboxIbu ? 'required' : ''"
          >
          <span v-show="errors.has('desa_ibu')" class="error-label">Isi Kelurahan</span>
        </div>
      </div>
      <div v-show="isExist('RW') && !checkboxIbu" :class="{'form-group': true, 'has-error': errors.has('rw_ibu')}">
        <label class="col-md-3"><span class="required-label">*</span>RW</label>
        <div class="col-md-6">
          <input
            type="text"
            name="rw_ibu"
            placeholder="RW"
            class="form-control"
            maxlength="25"
            v-model="model.rw_ibu"
            v-validate="isExist('RW') && !checkboxIbu ? 'required' : ''"
          >
          <span v-show="errors.has('rw_ibu')" class="error-label">Isi RW</span>
        </div>
      </div>
      <div v-show="isExist('RT') && !checkboxIbu" :class="{'form-group': true, 'has-error': errors.has('rt_ibu')}">
        <label class="col-md-3"><span class="required-label">*</span>RT</label>
        <div class="col-md-6">
          <input
            type="text"
            name="rt_ibu"
            placeholder="RT"
            class="form-control"
            maxlength="25"
            v-model="model.rt_ibu"
            v-validate="isExist('RT') && !checkboxIbu ? 'required' : ''"
          >
          <span v-show="errors.has('rt_ibu')" class="error-label">Isi RT</span>
        </div>
      </div>
      <div v-show="isExist('ALAMAT_RUMAH') && !checkboxIbu" :class="{'form-group': true, 'has-error': errors.has('alamat_lengkap_ibu')}">
        <label class="col-md-3"><span class="required-label">*</span>Alamat Rumah Ibu</label>
        <div class="col-md-6">
          <input
            type="text"
            name="alamat_lengkap_ibu"
            placeholder="Alamat Rumah Ibu"
            class="form-control"
            maxlength="25"
            v-model="model.alamat_lengkap_ibu"
            v-validate="isExist('ALAMAT_RUMAH') && !checkboxIbu ? 'required' : ''"
          >
          <span v-show="errors.has('alamat_lengkap_ibu')" class="error-label">Isi Alamat Rumah Ayah</span>
        </div>
      </div>
      <div v-show="isExist('KODE_POS') && !checkboxIbu" :class="{'form-group': true, 'has-error': errors.has('kode_pos_ibu')}">
        <label class="col-md-3"><span class="required-label">*</span>Kode Pos</label>
        <div class="col-md-6">
          <input
            type="text"
            name="kode_pos_ibu"
            placeholder="Kode Pos"
            class="form-control"
            maxlength="25"
            v-model="model.kode_pos_ibu"
            v-validate="isExist('KODE_POS') && !checkboxIbu ? 'required' : ''"
          >
          <span v-show="errors.has('kode_pos_ibu')" class="error-label">Isi Kode Pos</span>
        </div>
      </div>
      <div v-show="isExist('TELP') && !checkboxIbu" :class="{'form-group': true, 'has-error': errors.has('telp_ibu')}">
        <label class="col-md-3"><span class="required-label">*</span>Nomor Telepon</label>
        <div class="col-md-6">
          <input
            type="text"
            name="telp_ibu"
            placeholder="Nomor Telepon"
            class="form-control"
            maxlength="15"
            v-model="model.telp_ibu"
            v-validate="isExist('TELP') && !checkboxIbu ? 'required' : ''"
          >
          <span v-show="errors.has('telp_ibu')" class="error-label">Isi Nomor Telepon</span>
        </div>
      </div>
      <div v-show="isExist('HP') && !checkboxIbu" :class="{'form-group': true, 'has-error': errors.has('nohp_ibu')}">
        <label class="col-md-3"><span class="required-label">*</span>Nomor HP</label>
        <div class="col-md-6">
          <input
            type="text"
            name="nohp_ibu"
            placeholder="Nomor HP"
            class="form-control"
            maxlength="15"
            v-model="model.nohp_ibu"
            v-validate="isExist('HP') && !checkboxIbu ? 'required' : ''"
          >
          <span v-show="errors.has('nohp_ibu')" class="error-label">Isi Nomor HP</span>
        </div>
      </div>
      <div v-show="isExist('EMAIL') && !checkboxIbu" :class="{'form-group': true, 'has-error': errors.has('email_ibu')}">
        <label class="col-md-3"><span class="required-label">*</span>E-mail</label>
        <div class="col-md-6">
          <input
            type="text"
            name="email_ibu"
            placeholder="E-mail"
            class="form-control"
            maxlength="100"
            v-model="model.email_ibu"
            v-validate="isExist('EMAIL') && !checkboxIbu ? 'required|email' : 'email'"
          >
          <span v-show="errors.has('email_ibu')" class="error-label">Isi E-mail</span>
        </div>
      </div>
      <center>
        <pulse-loader style="margin: 15px" :loading="sending" color="#696969" size="10px"></pulse-loader>
      </center>
    </form>
  </div>
</template>

<script>
import api from '@/api'
import DateTimePicker from '@/components/DateTimePicker'
import kabupaten from '@/helper/data-master/kabupaten'
import kecamatan from '@/helper/data-master/kecamatan'
import Options from '@/helper/options'

export default {
  data () {
    return {
      init: false,
      loading: false,
      loadingKabupaten: false,
      loadingKecamatan: false,
      sending: false,
      checkboxIbu: false,
      model: {
        nama_lengkap_ibu: null,
        status_ibu: null,
        tempat_lahir_ibu: null,
        tanggal_lahir_ibu: null,
        id_agama_ibu: null,
        id_jenjang_pendidikan_ibu: null,
        pekerjaan_ibu: null,
        alamat_lengkap_ibu: null,
        rt_ibu: null,
        rw_ibu: null,
        desa_ibu: null,
        prop_ibu: null,
        kab_ibu: null,
        kec_ibu: null,
        id_negara_ibu: null,
        kode_pos_ibu: null,
        telp_ibu: null,
        nohp_ibu: null,
        email_ibu: null
      },
      savedModel: null,
      options: {
        kecamatan: [],
        kabupaten: [],
        provinsi: [],
        negara: [],
        agama: [],
        jenjang: [],
        status: [],
        pekerjaan: []
      }
    }
  },
  components: {
    'datetimepicker': DateTimePicker
  },
  computed: {
    nomorPendaftar () {
      return this.$store.getters.getAuthData.data.mhs_jalur.nomor_pendaftar
    },
    messages () {
      let message = ''
      this.$store.getters.getMessages(4).forEach(item => {
        message = message + ' ' + item.note + '.'
      })
      return message
    }
  },
  methods: {
    validate () {
      return new Promise((resolve, reject) => {
        this.validateForm()
          .then(valid => {
            this.sendData()
              .then(response => {
                resolve(true)
              })
              .catch(e => {
                e.data ? this.flash(e.data.message, 'error') : this.flash('maaf terjadi kesalahan', 'error')
                scroll(0, 0)
                resolve(false)
              })
          })
          .catch(e => {
            this.flash(e.message, 'error')
            scroll(0, 0)
            resolve(false)
          })
      })
    },
    validateForm () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll()
          .then(valid => {
            if (valid) {
              resolve(true)
            } else {
              reject({message: 'isian belum lengkap'})
            }
          })
      })
    },
    isExist (name) {
      return this.$store.getters.formIsExist(name, 4)
    },
    updateTglLahir (date) {
      this.model.tanggal_lahir_ibu = date
    },
    async initData () {
      if (!this.init) {
        this.isExist('PROVINSI') ? this.options.provinsi = await Options.getOptionsProvinsi() : false
        this.isExist('NEGARA') ? this.options.negara = await Options.getOptionsNegara() : false
        this.isExist('AGAMA_IBU') ? this.options.agama = await Options.getOptionsAgama() : false
        this.isExist('PEND_IBU') ? this.options.jenjang = await Options.getOptionsJenjang() : false
        this.isExist('PEKERJAAN_IBU') ? this.options.pekerjaan = await Options.getOptionsPekerjaan() : false
        this.isExist('STATUS_IBU') ? this.options.status = await Options.getOptionsStatus() : false
        this.getData()
        this.init = true
      }
    },
    getData () {
      this.loading = true
      api.get('/v1/data_orang_tua/' + this.nomorPendaftar)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            this.model = responseData.data
            this.model.kab_ibu === '0' ? this.model.kab_ibu = null : false
            this.model.kec_ibu === '0' ? this.model.kec_ibu = null : false
            this.model.prop_ibu ? this.onChangeProvinsi(false) : false
            this.model.kab_ibu ? this.onChangeKabupaten(false) : false
            this.loading = false
          }
        })
        .catch(e => {
          this.loading = false
        })
    },
    sendData () {
      return new Promise((resolve, reject) => {
        this.sending = true
        if (process.env.NODE_ENV !== 'test') {
          const model = JSON.stringify(this.model)
          if (model !== this.savedModel) {
            api.post('/v2/data_orang_tua/', {
              nomor_pendaftar: this.nomorPendaftar,
              ...this.model
            })
              .then(response => {
                this.sending = false
                this.savedModel = model
                resolve(response.data)
              })
              .catch(e => {
                this.sending = false
                reject(e.response)
              })
          } else {
            this.sending = false
            resolve(true)
          }
        } else {
          this.sending = false
          resolve(true)
        }
      })
    },
    async onChangeProvinsi (makenull) {
      this.loadingKabupaten = true
      try {
        this.options.kabupaten = await kabupaten.getByProvinsi(this.model.prop_ibu)
        if (makenull) {
          this.model.kab_ibu = null
          this.model.kec_ibu = null
        }
        this.loadingKabupaten = false
      } catch (e) {
        this.loadingKabupaten = false
        e.data ? this.flash(e.data.message, 'error') : this.flash('maaf terjadi kesalahan saat mengambil data provinsi', 'error')
        scroll(0, 0)
      }
    },
    async onChangeKabupaten (makenull) {
      this.loadingKecamatan = true
      try {
        this.options.kecamatan = await kecamatan.getByKabupaten(this.model.kab_ibu)
        makenull ? this.model.kec_ibu = null : false
        this.loadingKecamatan = false
      } catch (e) {
        this.loadingKecamatan = false
        e.data ? this.flash(e.data.message, 'error') : this.flash('maaf terjadi kesalahan saat mengambil data kecamatan', 'error')
        scroll(0, 0)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/register/DataIbu.vue